import { FC } from 'react'
import styled from 'styled-components'
import { AButton } from 'views/components/Analytics'
import { defaultTheme, Icons, Text } from '@agro-club/agroclub-shared'
import { useTranslation } from 'react-i18next'

const ControlsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 4px;
  user-select: none;
`

const SlideTrackerWrapper = styled.div`
  display: flex;
  column-gap: 6px;
  margin-top: 8px;
  margin-bottom: 14px;
`

const SlideTrackerItem = styled.div<{ isActive: boolean }>`
  width: ${({ isActive }) => (isActive ? '24px' : '16px')};
  height: 3px;
  border-radius: 1px;
  background-color: ${({ isActive }) => (isActive ? defaultTheme.color.secondary900 : defaultTheme.color.secondary300)};
  transition: all 0.3s ease-out;
`

type Props = {
  currentPage: number
  setCurrentPage: (page: number) => void
  total: number
}

export const SliderPaging: FC<Props> = ({ currentPage, setCurrentPage, total }) => {
  const { t } = useTranslation(['usContracts'])
  if (total <= 1) return null
  return (
    <ControlsWrapper>
      <AButton
        onClick={() => setCurrentPage(currentPage - 1)}
        disabled={currentPage === 1}
        color="black"
        background="none"
        Icon={Icons.IconArrowBackCenteredL}
        id="slider-left-button"
        size="small"
      />
      <Text typography="bodySmall" color="secondary">
        {currentPage} {t('common:of')} {total}
      </Text>
      <AButton
        onClick={() => setCurrentPage(currentPage + 1)}
        disabled={currentPage === total}
        color="black"
        background="none"
        Icon={Icons.IconArrowForwardCenteredL}
        id="slider-right-button"
        size="small"
      />
    </ControlsWrapper>
  )
}

type TrackerProps = {
  currentPage: number
  total: number
}

export const SliderTracker: FC<TrackerProps> = ({ currentPage, total }) => {
  if (total <= 1) return null
  return (
    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
      <SlideTrackerWrapper>
        {Array.from(Array(total).keys()).map((_, i) => (
          <SlideTrackerItem key={i} isActive={currentPage === i + 1} />
        ))}
      </SlideTrackerWrapper>
    </div>
  )
}
